import inputHtml from './input.html?raw';
import {InputObject} from './InputObject';

export const template = inputHtml;

/** Params are already an InputObject; use it as the KO binding context. */
export function viewModel(input: InputObject<unknown>): InputObject<unknown> {
    return input;
}
